import queryString from "query-string";

import {
    GET_PROJECT_TYPE
} from "@/api/master-data/project-type/project-type";

const state = {
    projectType: [],
};

const mutations = {
    setProjectType: (states, payload) => {
        states.projectType = payload;
    },
};

const actions = {
    getProjectType: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GET_PROJECT_TYPE(params);
            // console.log("resppp", resp)
            if (resp.data.httpCode === 200) {
                commit("setProjectType", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            // console.log(resp)
            if (resp.data.httpCode === 404) {
                commit("setProjectType", []);
            }
            throw err;
        }
    },
};

const getters = {
    ProjectType: (states) => states.projectType,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};